import { FC } from "react";
import { ReactComponent as IconWarning } from "../../assets/warning.svg";
import styles from "./BookingAvailabilityNotice.module.scss";

interface BookingAvailabilityNoticeProps {
  message: string;
}

const BookingAvailabilityNotice: FC<BookingAvailabilityNoticeProps> = ({
  message,
}) => {
  const normalizedMessage = message.trim();

  if (!normalizedMessage) return null;

  return (
    <div className={styles.container} role="status" aria-live="polite">
      <IconWarning aria-hidden="true" focusable="false" />
      <p>{normalizedMessage}</p>
    </div>
  );
};

export default BookingAvailabilityNotice;
